module.exports = {
      id: "my-vikatan-logo-usage",
      viewBox: "0 0 500 200",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#my-vikatan-logo",
      toString: function () {
        return this.url;
      }
    }